import { Link } from "react-router-dom";

function Navbar(){
    return (<nav style={{ position: 'sticky', top: '0px' }}>
            <div className="nav-header">
                <a href="#" className="menu-toggle" onClick="">&#9776;</a>
            </div>
            <div className="nav-links" id="navLinks">
                <Link to="/">Home</Link>
                <Link to="/about">About Us</Link>
                <Link to="/solutions">Solutions</Link>

                <div className="dropdown">
                    <a href="#">Products &#9662;</a>
                    <div className="dropdown-content">
                        <Link to="/products/line_interactive_UPS">Line Interactive UPS</Link>
                        <Link to="/products/servo_voltage_stabilizer">Servo Voltage Stabilizer</Link>
                        <Link to="/products/smf_battery">SMF Battery</Link>
                        <Link to="/products/online_UPS">Online UPS</Link>
                        <Link to="/products/electric_panels">Electrical Panel</Link>
                        <Link to="/products/industrial_inverters">Industrial Inverter</Link>
                        <Link to="/products/solar_system">Solar System</Link>
                        <Link to="/products/power_generator">Power Generator</Link>
                    </div>
                </div>
                <Link to="/services">Services</Link>
                <Link to="/gallery">Gallery</Link>
                <Link to="/contact">Contact</Link>
                <Link to="/adminLogin">Admin Login</Link>
            </div>
        </nav>)
}

export default Navbar;